import { render, staticRenderFns } from "./PendingCredits.vue?vue&type=template&id=6e539bb2&"
import script from "./PendingCredits.vue?vue&type=script&lang=js&"
export * from "./PendingCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports